export default "<div class=\"container\">\n    <h3>Aguarde...</h3>\n    <div class=\"lds-dual-ring\"></div>\n</div>"